import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { config } from './config';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: config.REACT_APP_INSTRUMENTATION_KEY,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true
    }
});
appInsights.loadAppInsights();
export { reactPlugin, appInsights };
